'use client'

import Link from 'next/link'

export default function Footer() {
  return (
    <footer className="w-full bg-[#1a1a1a] border-t border-[#222]">
      <div className="max-w-[2000px] mx-auto px-4 py-4">
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-[11px] mb-3">
          <button className="text-[#666] hover:text-[#999]">About</button>
          <span className="text-[#333]">|</span>
          <button className="text-[#666] hover:text-[#999]">Terms</button>
          <span className="text-[#333]">|</span>
          <button className="text-[#666] hover:text-[#999]">Privacy</button>
          <span className="text-[#333]">|</span>
          <button className="text-[#666] hover:text-[#999]">Shipping</button>
          <span className="text-[#333]">|</span>
          <button className="text-[#666] hover:text-[#999]">Returns</button>
          <span className="text-[#333]">|</span>
          <button className="text-[#666] hover:text-[#999]">FAQ</button>
          <span className="text-[#333]">|</span>
          <button className="text-[#666] hover:text-[#999]">Contact</button>
          <span className="text-[#333]">|</span>
          <Link href="/shop/operations" className="text-[#666] hover:text-[#999]">Operations</Link>
        </div>
        <div className="text-center text-[10px] text-[#444] font-mono">
          © 2024 DONGFENG · <span className="text-[#33ff33]">NODE:BD13</span> · <span className="text-[#666]">support@example.com</span>
        </div>
      </div>
    </footer>
  )
} 